/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optionally. 'Case-insensitive' treats 'Apple' and 'apple' as the same, and 'Trim each line' ignores leading and trailing spaces when comparing.`)
};

const es_rd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opcionalmente. 'Sin distinción de mayúsculas' trata 'Apple' y 'apple' como lo mismo, y 'Recortar cada línea' ignora espacios iniciales y finales al comparar.`)
};

const de_rd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional. 'Groß-/Kleinschreibung ignorieren' behandelt 'Apple' und 'apple' als identisch, und 'Jede Zeile trimmen' ignoriert führende und nachgestellte Leerzeichen beim Vergleich.`)
};

const nl_rd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optioneel. "Niet-hoofdlettergevoelig" behandelt "Apple" en "apple" als hetzelfde, en "Trim elke regel" negeert voorloop- en achtervolgende spaties bij het vergelijken.`)
};

const fr_rd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optionnellement. "Insensible à la casse" traite "Apple" et "apple" comme identiques, et "Supprimer les espaces" ignore les espaces de début et de fin lors de la comparaison.`)
};

const it_rd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facoltativamente. "Senza distinzione di maiuscole/minuscole" tratta "Apple" e "apple" come uguali, e "Rimuovi spazi da ogni riga" ignora gli spazi iniziali e finali durante il confronto.`)
};

const pt_br2_rd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opcionalmente. 'Insensível a maiúsculas' trata 'Apple' e 'apple' como iguais, e 'Aparar cada linha' ignora espaços iniciais e à direita ao comparar.`)
};

const pt_rd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opcionalmente. 'Sem distinção de maiúsculas' trata 'Apple' e 'apple' como sendo o mesmo, e 'Aparar cada linha' ignora espaços à esquerda e à direita ao comparar.`)
};

const ja_rd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意です。「大文字小文字を区別しない」では「Apple」と「apple」を同じものとして扱い、「各行をトリム」は比較するときに前後の空白を無視します。`)
};

const zh_rd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以选择开启。“不区分大小写”会将“Apple”和“apple”视为相同，“去除每行首尾空格”在比较时会忽略行首和行尾的空格。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rd_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rd_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rd_faq2_a", locale)
	if (locale === "en") return en_rd_faq2_a(inputs)
	if (locale === "es") return es_rd_faq2_a(inputs)
	if (locale === "de") return de_rd_faq2_a(inputs)
	if (locale === "nl") return nl_rd_faq2_a(inputs)
	if (locale === "fr") return fr_rd_faq2_a(inputs)
	if (locale === "it") return it_rd_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_rd_faq2_a(inputs)
	if (locale === "pt") return pt_rd_faq2_a(inputs)
	if (locale === "ja") return ja_rd_faq2_a(inputs)
	return zh_rd_faq2_a(inputs)
};